import { data } from '../../svg/DataObject/data';
import { makeIcon } from '../makeIcon';

export const DataObject = makeIcon(data, 'data_object', 'DataObject');

export default DataObject;
